"use client";

import BlockImage from "@/ui/common-components/block-image";
import { FC, useCallback } from "react";
import styles from "./card.module.scss";
import { ImageData } from "@/types/ui";
import { ClientSiteData } from "@/types/site";

export interface ICard {
  image: ImageData;
  title: string;
  text: string;
  link: string;
  isSmartphone: boolean;
  siteData: ClientSiteData;
}

const Card: FC<ICard> = ({ image, title, text, link, isSmartphone, siteData }) => {
  const cardClickHandler = useCallback(() => {
    window.open(link, link.includes("https") ? "_blank" : "_self");
  }, [link]);

  return (
    <div className={styles.card} onClick={cardClickHandler}>
      <div className={styles.imageContainer}>
        <BlockImage
          className={styles.image}
          image={image}
          lazyLoading={true}
          mobile={isSmartphone}
          siteData={siteData}
          alt={title}
        />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default Card;
